import {useHHttp} from '@/hooks/useHHttp'
import {showDialog, showToast} from "vant";
import {emitter, hcf} from "@/components/utils/HComFunctions.js";

let timer = null

const startPingPong = () => {
    let useHttp = useHHttp();

    useHttp.request('/api/pingpong', (data) => {
        processPingPong(data);
    }, {
        isShowLoading: false,
        isShowErrorToast: false,
        errCallBack: () => {
            processPingPong(null);
        }
    }).then(r => {
    });
}

const processPingPong = (data) => {
    if (data) {
        if (("List" in data) && data["List"]) {
            for (let eachPingPong of data["List"]) {
                if ('Data' in eachPingPong && eachPingPong["Data"] === null) continue

                switch (eachPingPong["Type"]) {
                    case 1://弹窗，我知道了: Title/Desc
                        showDialog({
                            title: eachPingPong["Title"],
                            message: eachPingPong["Desc"],
                            confirmButtonText: "知道了",
                            confirmButtonColor: hcf.getMainColor()
                        }).then(() => {
                        }).catch(() => {
                        });
                        break
                    case 2://底部提醒tips: Title
                        showToast(eachPingPong["Title"])
                        break
                    case 3:
                        emitter.emit('PING_PONG_EVENT_NO_RED_MSG', eachPingPong["Data"]["UnReadCount"] ?? 0)
                        break
                }
            }
        }

        if (("PingPong" in data) && data["PingPong"] > 0) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                startPingPong()
            }, data["PingPong"] * 1000)
        }
    } else {
        clearTimeout(timer)
        timer = setTimeout(() => {
            startPingPong()
        }, 10000)
    }
}

// 单例暴露
export const usePingPong = (() => {
    let started = false

    return () => {
        if (!started) {
            started = true
            startPingPong()
        }
    }
})()
